import { render, staticRenderFns } from "./DocCosignAutocomplete.vue?vue&type=template&id=5a2d770c&"
import script from "./DocCosignAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DocCosignAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./DocCosignAutocomplete.vue?vue&type=style&index=0&id=5a2d770c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports